import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import {RefreshIcon} from '../../../components/icons/action'

const StickyBar = ({survey, onRestart, proceedBtnDisabled, isPageMultiSelect}) => {
    const styles = useMultiStyleConfig('HelpMeChoose', {isPageMultiSelect})
    return (
        <Flex {...styles.stickyBarInnerContainer} data-testid="sticky-bar-container">
            <Flex {...styles.refreshBtnContainer}>
                <Button
                    {...styles.refreshBtn}
                    data-testid="refresh-btn"
                    onClick={onRestart}
                    leftIcon={<RefreshIcon boxSize="iconsSize.small" />}
                >
                    <Text as="span" {...styles.refreshBtnText}>
                        <FormattedMessage
                            id="helpMeChoose.refresh.button.label"
                            defaultMessage="Refresh"
                        />
                    </Text>
                </Button>
            </Flex>
            <Flex {...styles.stickyBarButtonsContainer}>
                {!survey.isCompleted && (
                    <Button
                        {...styles.goBackBtn}
                        data-testid="go-back-btn"
                        onClick={() => survey.prevPage()}
                    >
                        <FormattedMessage
                            id="helpMeChoose.go-back.button.label"
                            defaultMessage="Go back"
                        />
                    </Button>
                )}
                {isPageMultiSelect && (
                    <Button
                        {...styles.proceedBtn}
                        data-testid="proceed-btn"
                        onClick={() => survey.nextPage()}
                        isDisabled={proceedBtnDisabled}
                    >
                        <FormattedMessage
                            id="helpMeChoose.proceed.button.label"
                            defaultMessage="Proceed"
                        />
                    </Button>
                )}
            </Flex>
        </Flex>
    )
}

StickyBar.propTypes = {
    survey: PropTypes.object,
    onRestart: PropTypes.func,
    proceedBtnDisabled: PropTypes.bool,
    isPageMultiSelect: PropTypes.bool,
}

export default StickyBar
